import Vue from "vue";

/**
 * Coerce a CSV cell value according to Safetee synchronize field definitions.
 * Mirrors logic in stores/submodules/synchronize.js convertPayload.
 *
 * @param {unknown} value
 * @param {{ type?: string, value?: string }} fieldDef
 * @param {string} lastFieldKey
 * @returns {unknown}
 */
export function coerceCsvCellValue(value, fieldDef, lastFieldKey) {
    if (value === "") {
        return null;
    }
    let col = value;
    const fieldType = fieldDef?.type;
    const fieldValue = fieldDef?.value;

    if (fieldType === "number") {
        const normalized = String(col).trim().replace(",", ".");
        return Number.parseFloat(normalized);
    }
    if (fieldType === "boolean") {
        if (col === null || col === undefined) {
            return col;
        }
        const colLower = String(col).toLowerCase();
        if (
            colLower === "false" ||
            colLower === "no" ||
            colLower === "0" ||
            colLower === Vue.prototype.$translate("false") ||
            colLower === Vue.prototype.$translate("no")
        ) {
            return false;
        }
        return (
            colLower === "1" ||
            colLower === "true" ||
            colLower === "yes" ||
            colLower === Vue.prototype.$translate("true") ||
            colLower === Vue.prototype.$translate("yes")
        );
    }
    if (
        fieldType === "phone number" ||
        fieldType === "phone_number" ||
        fieldValue === "phone_number" ||
        fieldValue === "mobile_phone_number" ||
        lastFieldKey === "phone_number" ||
        lastFieldKey === "mobile_phone_number"
    ) {
        if (col !== null && typeof col === "string") {
            return col.replace(/\s+/g, "");
        }
    }
    return col;
}

/**
 * @param {Record<string, unknown>} obj
 * @param {string} dottedKey e.g. metadata.color
 * @param {unknown} value
 */
export function setNestedValue(obj, dottedKey, value) {
    const parts = dottedKey.split(".");
    let current = obj;
    for (let i = 0; i < parts.length - 1; i += 1) {
        if (!current[parts[i]]) {
            current[parts[i]] = {};
        }
        current = current[parts[i]];
    }
    current[parts[parts.length - 1]] = value;
}

/**
 * @param {string} value
 * @returns {string|null}
 */
export function normalizeDecimalString(value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    const normalized = String(value).trim().replace(",", ".");
    const parsed = Number.parseFloat(normalized);
    if (Number.isNaN(parsed)) {
        return null;
    }
    return String(parsed);
}
